/**
 * Machinery Module Routes (extracted from index.tsx)
 */
import React from 'react';
import { Result } from 'antd';
import { RouteItem } from './index';
import { HomeOutlined, FormOutlined, OrderedListOutlined, PlusOutlined, TeamOutlined, FolderOutlined } from '@ant-design/icons';
import { ToolOutlined as MachineOutlined, SettingOutlined as MaintenanceOutlined } from '@ant-design/icons';

// Shared forms
import FormDefinitionsList from "../components/common/Forms/FormDefinitionsList";
import FormDefinitionEditor from "../components/common/Forms/FormDefinitionEditor";
import PdfToReactFormGenerator from "../components/common/Forms/PdfToReactFormGenerator";
import FormRecordDetailsList from '../components/common/Forms/FormRecordDetailsList';

// Machinery pages
import MachFormsCreate from "../pages/machinery/forms/MachFormsCreate";
import MachFormFill from "../pages/machinery/forms/MachFormFill";
import MachFormList from "../pages/machinery/forms/MachFormList";
import MachFormEdit from '../pages/machinery/forms/MachFormEdit';
import MachFormView from '../pages/machinery/forms/MachFormView';
import MachFormGroupCreate from "../pages/machinery/forms/MachFormGroupCreate";

import VehicleFuelMain from '../pages/machinery/fuel';
import VehicleFuelImport from '../pages/machinery/fuel/VehicleFuelImport';
import MachineryMain from '../pages/machinery';

import MachConstMachinesList from '../pages/machinery/machines/MachConstMachinesList';
import MachConstMachineDetail from '../pages/machinery/machines/MachConstMachineDetail';

// Maintenance (make static, no lazy)
import MachMaintenanceList from '../pages/machinery/maintenance/MachMaintenanceList';
import MachMaintenanceTypes from '../pages/machinery/maintenance/MachMaintenanceTypes';
import MachMaintenanceRules from '../pages/machinery/maintenance/MachMaintenanceRules';
import MachMaintenanceAlerts from '../pages/machinery/maintenance/MachMaintenanceAlerts';

// Assignments
import MachAssignmentsList from '../pages/machinery/assignments/MachAssignmentsList';

// Vehicles
import MecVehicleList from  '../pages/machinery/vehicles/MecVehicleList';
import MecVehicleDetail from  '../pages/machinery/vehicles/MecVehicleDetail';

// Reservations / Allocations
import MachMachineAllocationsList from '../pages/machinery/allocations/MachMachineAllocationsList';
import MachMachineAllocationCreate from '../pages/machinery/allocations/MachMachineAllocationCreate';
import MachMachineAllocationView from '../pages/machinery/allocations/MachMachineAllocationView';

const UnderConstruction = ({ title }: { title: string }) => (
  <Result status="info" title={`${title} Module`} subTitle="Under Construction." />
);

export const machineryRoutes: Record<string, RouteItem> = {
  // MACHINERY modülü
  machinery: {path: '/machinery', element: <MachineryMain />, label: 'Machinery', showInMenu: false,
    children: {
      dashboard: {path: '/machinery/dashboard', element: <MachineryMain />, label: 'Dashboard', icon: <HomeOutlined />, showInMenu: true},
      forms: {path: '/machinery/forms', element: <MachFormList/>, label: 'Forms', icon: <FormOutlined />, showInMenu: true,
        grandchildren: {
          list: {path: '/machinery/forms/list', element: <MachFormList/>, label: 'Form List', icon: <OrderedListOutlined/>, showInMenu: true},
          definitions: {path: '/machinery/forms/definitions', element: <FormDefinitionsList />, label: 'Form Definitions', icon: <OrderedListOutlined />, showInMenu: true},
          definitions_create: {path: '/machinery/forms/definitions/create', element: <PdfToReactFormGenerator />, label: 'Create Form Definition', showInMenu: false},
          definitions_edit: {path: '/machinery/forms/definitions/edit/:id', element: <FormDefinitionEditor />, label: 'Edit Form Definition', showInMenu: false},
          list_record_details: {path: '/machinery/forms/list_record_details', element: <FormRecordDetailsList />, label: 'Form Record Details', icon: <OrderedListOutlined/>, showInMenu: true},
          group: {path: '/machinery/forms/gr_create', element: <MachFormGroupCreate />, label: 'New Form Group', icon: <PlusOutlined />, showInMenu: true},
          create: {path: '/machinery/forms/create', element: <MachFormsCreate/>, label: 'Create Form', icon: <PlusOutlined />, showInMenu: true},
          fill: {path: '/machinery/forms/fill', element: <MachFormFill/>, label: 'Fill Form',  showInMenu: true},
          edit: {path: '/machinery/forms/edit/:id', element: <MachFormEdit />, label: 'Edit Form', showInMenu: false},
          view: {path: '/machinery/forms/view/:id', element: <MachFormView />, label: 'View Form', showInMenu: false},
        },
      },
      fuel: {path: '/machinery/fuel', element: <VehicleFuelMain />, label: 'Fuel Tracking', showInMenu: true,
        // Use grandchildren so header menu can render a dropdown arrow (like Maintenance)
        grandchildren: {
          overview: { path: '/machinery/fuel/overview', element: <VehicleFuelMain />, label: 'Fuel Overview', showInMenu: true },
          entry: { path: '/machinery/fuel/entry', element: <VehicleFuelMain />, label: 'Fuel Entry', showInMenu: true },
          history: { path: '/machinery/fuel/history', element: <VehicleFuelMain />, label: 'Fuel History', showInMenu: true },
          pumps: { path: '/machinery/fuel/pumps', element: <VehicleFuelMain />, label: 'Fuel Pumps', showInMenu: true },
          transfers: { path: '/machinery/fuel/transfers', element: <VehicleFuelMain />, label: 'Fuel Transfers', showInMenu: true },
          import: { path: '/machinery/fuel/import', element: <VehicleFuelImport />, label: 'Fuel Import', showInMenu: true }
        }
      },
      machines: {path: '/machinery/machines', element: <MachConstMachinesList />, label: 'Machines', icon: <MachineOutlined />, showInMenu: true},
      byid: {path: '/machinery/machines/show/:id', element: <MachConstMachineDetail />, label: 'Machine Detail',showInMenu: false},
      maintenance: {path: '/machinery/maintenance', element: <MachMaintenanceList />, label: 'Maintenance', icon: <MaintenanceOutlined />, showInMenu: true,
        grandchildren: {
          types: { path: '/machinery/maintenance/types', element: <MachMaintenanceTypes />, label: 'Types', showInMenu: true },
          rules: { path: '/machinery/maintenance/rules', element: <MachMaintenanceRules />, label: 'Rules', showInMenu: true },
          alerts: { path: '/machinery/maintenance/alerts', element: <MachMaintenanceAlerts />, label: 'Alerts', showInMenu: true },
        }
      },
      assignments: {path: '/machinery/assignments', element: <MachAssignmentsList />, label: 'Assignments', icon: <TeamOutlined />, showInMenu: true},
      vehicles: {path: '/machinery/vehicles', element: <MecVehicleList />, label: 'Vehicles', icon: <MaintenanceOutlined />, showInMenu: true,
        children: {
          detail: {path: '/machinery/vehicles/show/:id', element: <MecVehicleDetail />, showInMenu: false},
        }
      },
      allocations: {path: '/machinery/allocations', element: <MachMachineAllocationsList />, label: 'Reservations / Allocation', icon: <FolderOutlined />, showInMenu: true,
        children: {
          list:   { path: '/machinery/allocations/list', element: <MachMachineAllocationsList />, label: 'Reservation List', showInMenu: false },
          create: { path: '/machinery/allocations/create', element: <MachMachineAllocationCreate />, label: 'Create Reservation', showInMenu: false },
          view:   { path: '/machinery/allocations/view/:id', element: <MachMachineAllocationView />, label: 'Reservation Detail', showInMenu: false },
        }
      },
    },
  },
};
